/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TableCell, TableRow } from '@mui/material';

import { Namespaces } from '../../../../../../../../i18n';
import { useTableStyles } from '../../../../../../../../styles/table';
import { useDatasetImportsTableOperationHeadingStyles } from './DatasetImportsTableOperationHeading.styles';

export function DatasetImportsTableOperationHeading() {
  const tableClasses = useTableStyles();
  const classes = useDatasetImportsTableOperationHeadingStyles();
  const { t } = useTranslation(Namespaces.Cluster);

  return (
    <TableRow>
      <TableCell className={cx(tableClasses.bodyTableCell, classes.cell)} />
      <TableCell className={cx(tableClasses.bodyTableCell, classes.cell)} />
      <TableCell className={cx(tableClasses.bodyTableCell, classes.cell)} />
      <TableCell
        classes={{
          root: cx(tableClasses.bodyTableCell, classes.cell),
        }}
      >
        {t('details.datasets.table.operation_type')}
      </TableCell>
      <TableCell
        classes={{
          root: cx(tableClasses.bodyTableCell, classes.cell),
        }}
      >
        {t('details.datasets.table.import_start')}
      </TableCell>
      <TableCell
        classes={{
          root: cx(tableClasses.bodyTableCell, classes.cell),
        }}
      >
        {t('details.datasets.table.import_end')}
      </TableCell>
      <TableCell
        classes={{
          root: cx(tableClasses.bodyTableCell, classes.cell),
        }}
      >
        {t('details.datasets.table.result')}
      </TableCell>
      <TableCell className={cx(tableClasses.bodyTableCell, classes.cell)} />
    </TableRow>
  );
}
